import { connect } from 'react-redux';

import { showModal } from '../../actions';
import Header from './Header';


export default connect(null, { openModal: showModal })(Header);
